import { VideoCallIssueType, VideoCallProblemType } from 'enums/videoCall';

export interface StaffFeedbackProps {
  comment?: string;
  createdAt: string;
  issueDescriptions?: VideoCallProblemType[];
  issueType?: VideoCallIssueType;
  patientInfo: {
    name: string;
  };
  providerInfo: {
    name: string;
  };
  roomName: string;
  status: string;
}
export interface StaffFeedbackQueryParams {
  createdAt?: string;
  endCreateDate?: string;
  issueDescriptions?: string[];
  issueType?: string;
  limit?: number;
  pageNo?: number;
  patientName?: string;
  providerName?: string;
  roomName?: string;
  searchKey?: string;
  sortField?: string;
  sortOrder?: string;
  startCreateDate?: string;
  status?: string;
}

export interface StaffFeedbackListProps {
  data: StaffFeedbackProps[];
  info: {
    totalCount: number;
  };
}

export const initialState: StaffFeedbackListProps = {
  data: [
    {
      createdAt: '',
      patientInfo: {
        name: ''
      },
      providerInfo: {
        name: ''
      },
      roomName: '',
      status: ''
    }
  ],
  info: {
    totalCount: 0
  }
};
